import React, { useMemo } from 'react';
import { DragDropProvider } from '@dnd-kit/react';
import { Column } from './Column';
import { Item } from './Item';
import { useEPMContext } from '../../../contexts/EPMContext';
import { useUserContext } from '../../../contexts/UserContext';
import { permission } from '../../../config/permission';
import { useBoardDnD } from './useBoardDnD';
import { COLUMN_LABELS } from './constants';
import { tagIdsOf } from '../epmHelpers';
import './styles.css';

export function Board({ onTestClick, tagFilter = [] }) {
    const { tests, tagsMap, setTests } = useEPMContext();
    const { userData, checkPermission } = useUserContext();
    const canUpdate = checkPermission(permission.XCM_TESTS_UPDATE);

    // A card shows when it carries any of the selected tags
    const visibleTests = useMemo(() => (tagFilter.length
        ? (tests || []).filter((test) => tagIdsOf(test).some((id) => tagFilter.includes(id)))
        : tests), [tests, tagFilter]);

    const {
        items,
        columnOrder,
        handleDragStart,
        handleDragOver,
        handleDragEnd,
    } = useBoardDnD({ tests: visibleTests, setTests, userData });

    return (
        <DragDropProvider
            onDragStart={canUpdate ? handleDragStart : undefined}
            onDragOver={canUpdate ? handleDragOver : undefined}
            onDragEnd={canUpdate ? handleDragEnd : undefined}
        >
            {/* w-0 min-w-full: the columns scroll inside the board and never widen the page,
                whatever width the side nav is */}
            <div className="board flex gap-4 overflow-x-auto items-start py-1 pb-4 min-h-[500px] w-0 min-w-full">
                {columnOrder.map((column, columnIndex) => (
                    <Column
                        key={column}
                        id={column}
                        index={columnIndex}
                        label={COLUMN_LABELS[column]}
                    >
                        {items[column].map((test, index) => (
                            <Item
                                key={test.id}
                                id={test.id}
                                index={index}
                                column={column}
                                test={test}
                                tagsMap={tagsMap}
                                onClick={() => onTestClick?.(test.id)}
                                disabled={!canUpdate}
                            />
                        ))}
                    </Column>
                ))}
            </div>
        </DragDropProvider>
    );
}

export default Board;

